import React, {useState} from 'react';
import styles from './selling-agent-section.module.scss';
import {Table, Row, Button} from "react-bootstrap";
import {toCurrency} from "../../../../../../helpr/helper";
import {SECURITY_AUTHORIZED, SECURITY_ADCU_REJECTED} from "../../../../../../helpr/constants";
import acceptIcon from "../../../../../../assets/orders-table-accept.svg";
import pendingIcon from "../../../../../../assets/orders-table-pending.svg";
import ModalCustom from "../../../../../../components/modal/modal";
import BpIdGenerationModalContent from "../bpid-generation-modal-content/bpid-generation-modal-content";
import PCodeGenerationModalContent from "../pcode-generation-modal-content/pcode-generation-modal-content";
import RejectSalesReportModalContent from "../reject-sales-report-modal-content/reject-sales-report-modal-content";
import SecurityService from "../../../../../../services/security-service";

const SellingAgentSection = ({security, sellingAgents}) => {
  const securityService = new SecurityService();
  const [modalState, setModalState] = useState({
    title: '',
    show: false,
    component: '',
    shouldRefreshOnClose: false
  });

  const headers = [
    'Selling Agent',
    'Allocation',
    'Status',
    'BP ID',
    'Participant Code',
    'Date Submitted',
    ''
  ];

  const downloadBPFeed = async (entityId) => {
    const resp = await securityService.generateBPFeed(security.securityId, entityId);
    window.open(resp['bpFeedS3FileUrl']);
    window.open(resp['fisipoS3FileUrl']);
  }

  const allocateSecurity = async (entityId) => {
    const resp = await securityService.allocateSecurity(security.securityId, entityId);
    // window.open(resp['bpFeedS3FileUrl']);
    // window.open(resp['fisipoS3FileUrl']);
  }


  const renderStatus = status => {
    switch(status){
      case SECURITY_AUTHORIZED:
        return <span><img alt="Submitted" src={acceptIcon}/>  Submitted</span>
      case SECURITY_ADCU_REJECTED:
        return <span><img alt="Submitted" src={acceptIcon}/>  Rejected</span>
      default:
        return <span><img alt="Pending" src={pendingIcon}/>  Ongoing</span>
    }
  }

  const downloadSalesReport = async (entityId) => {
    const resp = await securityService.generateSalesReport(security.securityId, entityId);
    window.open(resp['s3FileUrl']);
  }

  //Modal actions
  const closeModal = () => {
    const shouldRefresh = modalState.shouldRefreshOnClose;
    if (shouldRefresh) {
      window.location.reload();
    } else {
      setModalState({
        show: false,
        title: '',
        component: '',
        shouldRefreshOnClose: false
      });
    }
  }
  const showBpIdGenerationModal = (entityId) => {
    const component = <BpIdGenerationModalContent securityId={security.securityId} entityId={entityId} onClose={() => closeModal()}/>
    setModalState({
      ...modalState,
      title: "Generate BP ID",
      show: true,
      component: component
    });
  }

  const showPCodeGenerationModal = (entityId) => {
    const component = <PCodeGenerationModalContent securityId={security.securityId} entityId={entityId} onClose={() => closeModal()}/>
    setModalState({
      ...modalState,
      title: "Generate Participant Code",
      show: true,
      component: component
    });
  }

  const showRejectSecurityModal = (entityId) => {
    const handleSuccess = () => {
      setModalState(prev => ({
        ...prev,
        shouldRefreshOnClose: true
      }));
    };
    const component = <RejectSalesReportModalContent 
      securityId={security.securityId} 
      entityId={entityId} 
      onClose={() => closeModal()}
      onSuccess={handleSuccess}
    />
    setModalState({
      title: "Reject Sales Report",
      show: true,
      component: component,
      shouldRefreshOnClose: false
    });
  }

  return (
    <>
      <div className={styles['selling-agent-section']}>
        <Row>
          { sellingAgents.length > 0 ?
            <Table responsive>
              <thead>
              <tr>
                {headers.map((header, index)=>{
                  return <th key={index}>{header}</th>
                })}
              </tr>
              </thead>
              <tbody>
              { sellingAgents.map((data, index)=> {
                console.log(data);
                return (
                  <tr key={"table-"+index}>
                    <td style={{whiteSpace: 'unset'}}>{data['sellingAgentName']}</td>
                    <td>{toCurrency(data['allocation'])}</td>
                    <td>{renderStatus(data['securityStatus'])}</td>
                    <td>{data['bpId']}</td>
                    <td>{data['participantCode']}</td>
                    <td>{data['authorizedDate'] ? data['authorizedDate'] : '-'}</td>
                    <td className={styles['td-button']}>
                      <div className={styles['button-actions']}>
                        <div className={styles['button-action']}>
                          <Button
                            onClick={() => showBpIdGenerationModal(data['sellingAgentEntityId'])}
                            disabled={data['bpId']!=='' || data['securityStatus'] !== SECURITY_AUTHORIZED}>
                              Assign BPID
                          </Button>
                        </div>
                        <div className={styles['button-action']}>
                          <Button
                            onClick={() => showPCodeGenerationModal(data['sellingAgentEntityId'])}
                            disabled={data['participantCode']!='' || data['securityStatus'] !== SECURITY_AUTHORIZED}>
                            Assign Participant Code
                          </Button>
                        </div>
                        <div className={styles['button-action']}>
                          <Button
                            onClick={()=>{downloadSalesReport(data['sellingAgentEntityId'])}}>
                              Download Sales Report
                          </Button>
                        </div>
                        <div className={styles['button-action']}>
                          <Button 
                            onClick={()=>downloadBPFeed(data['sellingAgentEntityId'])}
                            disabled={ data['participantCode'] === '' || data['bpId'] === '' || data['securityStatus'] !== SECURITY_AUTHORIZED }>
                            Generate BPFeed
                          </Button>
                        </div>
                        <div className={styles['button-action']}>
                          <Button 
                            variant="danger"
                            onClick={() => showRejectSecurityModal(data['sellingAgentEntityId'])}
                            disabled={data['participantCode'] !== '' || data['bpId'] !== '' || data['securityStatus'] !== SECURITY_AUTHORIZED}>
                            Reject Sales Report
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )
              }) }
              </tbody>
            </Table>
            : <div className={styles['no-data']}>No selling agents to display</div>}
        </Row>
      </div>
      <ModalCustom
        show={modalState.show}
        title={modalState.title}
        onClose={() => closeModal()}
        component={modalState.component}
        style={styles['id-generation-modal']} />
    </>
  )
}

export default SellingAgentSection;

